import React, { useCallback, useEffect, useRef, useState } from 'react';
import InfiniteScrollContainer from './InfiniteScrollContainer';
import { Box } from '@mui/material';

const InfiniteScroll = ({ data, Component, offset, totalCount, handleFetch }) => {
    const pageRef = useRef({
        start: 0,
        end: 0,
    });
    const [hasStart, setHasStart] = useState(false);
    const [hasEnd, setHasEnd] = useState(false);
    const [isLoadingStart, setIsLoadingStart] = useState(false);
    const [isLoadingEnd, setIsLoadingEnd] = useState(false);
    const boxRef = useRef(null);

    const fetchData = useCallback(
        async (loadEnd) => {
            if (loadEnd) {
                await handleFetch(pageRef.current.end, true);
                const currentTotalCount = (pageRef.current.end + 1) * offset;
                setHasEnd(currentTotalCount < totalCount);
                setHasStart(true);
                setIsLoadingEnd(false);
            } else {
                await handleFetch(pageRef.current.start, false);
                setHasEnd(true);
                setHasStart(pageRef.current.start >= 0);
                setIsLoadingStart(false);
                if (boxRef.current && offset !== 0) boxRef.current.scrollTop = 125;
            }
        },
        [totalCount],
    );

    useEffect(() => {
        fetchData();
    }, []);

    const loadStart = useCallback(() => {
        if (pageRef.current.start === 0) return;
        const start = pageRef.current.start;
        pageRef.current.start = pageRef.current.end - 2;
        pageRef.current.end = start;
        setIsLoadingStart(true);
        fetchData(false);
    }, [fetchData]);

    const loadEnd = useCallback(() => {
        pageRef.current.start = pageRef.current.end;
        pageRef.current.end = pageRef.current.end + 1;
        setIsLoadingEnd(true);
        fetchData(true);
    }, [fetchData]);

    return (
        <Box
            ref={boxRef}
            sx={{
                maxHeight: '500px',
                overflowY: 'auto',
                padding: '0 20px 20px 20px',
            }}
        >
            {data.length > 0 && (
                <InfiniteScrollContainer
                    hasEnd={hasEnd}
                    hasStart={hasStart}
                    isLoadingStart={isLoadingStart}
                    isLoadingEnd={isLoadingEnd}
                    loadStart={loadStart}
                    loadEnd={loadEnd}
                    data={data}
                    Component={Component}
                />
            )}
        </Box>
    );
};

export default InfiniteScroll;
